import { useState } from "react";
import { createStripeAdapterAxiosClient } from "../../Stripe/createStripeAdapterAxiosClient.ts";
import { StripeOrderDTO } from "../../Stripe/StripeOrderDTO.ts";

export function useUpdateStripePaymentMethod() {
  const [loading, setLoading] = useState(false);

  const updatedOrder = async (orderId: string) => {
    try {
      setLoading(true);
      const { data: order } =
        await createStripeAdapterAxiosClient().post<StripeOrderDTO>(
          `/payment-intent/update-payment-method`,
          {
            orderId: orderId,
          },
        );

      return {
        order,
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    updatedOrder: updatedOrder,
    loading,
  };
}
